import {
  Autocomplete,
  TextField,
  styled,
  Typography,
  Grid,
  Divider,
  MenuItem,
  Box,
} from '@mui/material';
import React from 'react';
import DynamicIcons from '../CredentialStore/DynamicIcons';

const SelectLabel = styled(Typography)({
  paddingBottom: '8px',
  fontFamily: 'Open Sans !important',
  fontSize: '14px',
  fontWeight: '400 !important',
  lineHeight: '19.07px',
  textAlign: 'left',
});

const DividerHeader = styled('li')(({ theme }) => ({
  padding: '8px 16px',
  color: theme.palette.text.secondary,
  fontSize: '14px',
  fontWeight: 500,
}));

const W86AutoCompleteMenuItem = styled(MenuItem)({
  display: 'flex',
  alignItems: 'center',
  '& > *:first-of-type': {
    marginRight: '16px',
  },
});

const IconBox = styled(Box)({
  paddingLeft: '8px',
  paddingRight: '8px',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

/**
 * Custom Autocomplete with option to include icon
 * @param title Title that appears on top of the Autocomplete component
 * @param value The value being selected
 * @param onChange
 * @param options List of options available for the dropdown
 * @param disabled True to disable the Autocomplete
 * @param renderOptionIcon Function to direct where the icon is in the option
 * @param renderOptionHeader Function to direct where the Header value is in the option
 * @param renderOptionLabel Function to direct where the option label/name value is in the option
 * @param inputPlaceholder Placeholder for the input if nothing is selected
 */

const W86AutoComplete = ({
  title,
  value,
  onChange,
  options,
  renderOptionLabel,
  disabled,
  renderOptionIcon,
  renderOptionHeader,
  inputPlaceholder,
}) => {
  const handleRenderOption = (props, option) => {
    const divider = option?.divider;
    const header = renderOptionHeader ? renderOptionHeader(option) : option?.header;
    const optionIcon = renderOptionIcon ? renderOptionIcon(option) : option?.icon;
    const optionLabel = renderOptionLabel ? renderOptionLabel(option) : option;

    if (divider) {
      return [
        <Divider key="divider" />,
        <DividerHeader key="header">{header}</DividerHeader>,
        <W86AutoCompleteMenuItem {...props}>
          {optionIcon && <DynamicIcons icons={[optionIcon]} />}
          {optionLabel}
        </W86AutoCompleteMenuItem>,
      ];
    }
    return (
      <W86AutoCompleteMenuItem {...props}>
        {optionIcon && <DynamicIcons icons={[optionIcon]} />}
        {optionLabel}
      </W86AutoCompleteMenuItem>
    );
  };
  const handleRenderInput = params => {
    const icon = renderOptionIcon ? renderOptionIcon(value) : value?.icon;
    return (
      <TextField
        {...params}
        placeholder={inputPlaceholder}
        size="small"
        InputProps={{
          ...params.InputProps,
          startAdornment: (
            <>
              {icon && (
                <IconBox>
                  <DynamicIcons icons={[icon]} />
                </IconBox>
              )}
              {params.InputProps.startAdornment}
            </>
          ),
        }}
      />
    );
  };
  return (
    <Grid item xs={12}>
      <SelectLabel>{title}</SelectLabel>
      <Autocomplete
        value={value}
        onChange={onChange}
        options={options}
        getOptionLabel={renderOptionLabel}
        renderOption={handleRenderOption}
        renderInput={handleRenderInput}
        fullWidth
        autoHighlight
        disabled={disabled}
      />
    </Grid>
  );
};

export default W86AutoComplete;
